module.exports = __webpack_public_path__ + "media/images/login-3087a32704dad532dff18312b6df460d.png";